// extracted by mini-css-extract-plugin
export default {"cls1":"hcTHue2njVbKvc1ZTaTU","cls2":"d0FiuogVJw3wZjT4yZ76 hcTHue2njVbKvc1ZTaTU"};